import { L, vocabulary } from '../define.js';
/** D577 slice d: governance-market. */
export const GOVERNANCE_MARKET_VOCABULARIES = [
    vocabulary('market.country_operation_state', '@vello/governance COUNTRY_OPERATION_STATES', {
        DRAFT: L('Rascunho', 'Draft', 'Borrador', 'Bozza'),
        LEGAL_REVIEW: L('Revisão jurídica', 'Legal review', 'Revisión jurídica', 'Revisione legale'),
        TECHNICAL_VALIDATION: L('Validação técnica', 'Technical validation', 'Validación técnica', 'Validazione tecnica'),
        APPROVED: L('Aprovado', 'Approved', 'Aprobado', 'Approvato'),
        SUSPENDED: L('Suspenso', 'Suspended', 'Suspendido', 'Sospeso'),
        RETIRED: L('Encerrado', 'Retired', 'Retirado', 'Chiuso'),
    }),
    vocabulary('market.dispatch_strategy', '@vello/governance DISPATCH_STRATEGIES', {
        proximity: L('Proximidade', 'Proximity', 'Proximidad', 'Prossimità'),
        queue: L('Fila', 'Queue', 'Cola', 'Coda'),
        zones: L('Zonas', 'Zones', 'Zonas', 'Zone'),
        bid: L('Lance', 'Bid', 'Puja', 'Offerta'),
        multi: L('Múltiplas ofertas', 'Multiple offers', 'Múltiples ofertas', 'Offerte multiple'),
        dynamic: L('Dinâmico', 'Dynamic', 'Dinámico', 'Dinamico'),
    }),
    vocabulary('rbac.approval_role', '@vello/governance REQUIRED_ACTIVATION_APPROVAL_ROLES; @vello/governance REQUIRED_COUNTRY_APPROVAL_ROLES', {
        LEGAL: L('Jurídico', 'Legal', 'Jurídico', 'Legale'),
        FINANCE: L('Financeiro', 'Finance', 'Finanzas', 'Finanza'),
        COMPLIANCE: L('Conformidade', 'Compliance', 'Cumplimiento', 'Conformità'),
    }),
    vocabulary('pricing_governance.rule_status', '@vello/pricing-governance PricingRuleStatus', {
        DRAFT: L('Rascunho', 'Draft', 'Borrador', 'Bozza'),
        PENDING_APPROVAL: L('Aguardando aprovação', 'Pending approval', 'Pendiente de aprobación', 'In attesa di approvazione'),
        ACTIVE: L('Ativa', 'Active', 'Activa', 'Attiva'),
        ARCHIVED: L('Arquivada', 'Archived', 'Archivada', 'Archiviata'),
    }),
    vocabulary('problem.pricing_governance', '@vello/pricing-governance GovernanceError', {
        WRONG_STATUS: L('A regra não está na situação certa para esta ação.', 'The rule is not in the right status for this action.', 'La regla no está en el estado correcto para esta acción.', 'La regola non è nello stato giusto per questa azione.'),
        PERMISSION_MISMATCH: L('A permissão não corresponde a esta ação.', 'The permission does not match this action.', 'El permiso no corresponde a esta acción.', 'Il permesso non corrisponde a questa azione.'),
        TAMPERED: L('A regra foi alterada depois da aprovação.', 'The rule was changed after approval.', 'La regla se cambió después de la aprobación.', 'La regola è stata modificata dopo l’approvazione.'),
    }, 'message'),
    vocabulary('demand_forecast.model_state', '@vello/demand-forecast MODEL_STATES', {
        REGISTERED: L('Registrado', 'Registered', 'Registrado', 'Registrato'),
        SHADOW: L('Em teste paralelo', 'Shadow testing', 'En prueba paralela', 'In test parallelo'),
        APPROVED: L('Aprovado', 'Approved', 'Aprobado', 'Approvato'),
        RETIRED: L('Aposentado', 'Retired', 'Retirado', 'Ritirato'),
    }),
    vocabulary('problem.demand_forecast', '@vello/demand-forecast RegistryError', {
        INVALID_LINEAGE: L('A origem do modelo é inválida.', 'The model’s lineage is invalid.', 'El origen del modelo no es válido.', 'L’origine del modello non è valida.'),
        NOT_SHADOW: L('O modelo não está em teste paralelo.', 'The model is not in shadow testing.', 'El modelo no está en prueba paralela.', 'Il modello non è in test parallelo.'),
    }, 'message'),
    vocabulary('experiments.campaign_decision', '@vello/experiments CampaignDecision', {
        scale: L('Ampliar', 'Scale up', 'Ampliar', 'Ampliare'),
        hold: L('Manter como está', 'Hold', 'Mantener como está', 'Mantenere'),
        stop: L('Encerrar', 'Stop', 'Terminar', 'Terminare'),
    }),
    vocabulary('action_gateway.action_domain', '@vello/action-gateway ACTION_DOMAINS', {
        ride: L('Corridas', 'Rides', 'Viajes', 'Corse'),
        driver: L('Motoristas', 'Drivers', 'Conductores', 'Autisti'),
        support: L('Atendimento', 'Support', 'Atención al cliente', 'Assistenza'),
        finance: L('Financeiro', 'Finance', 'Finanzas', 'Finanza'),
        food: L('Comida', 'Food', 'Comida', 'Cibo'),
        send: L('Encomendas', 'Parcels', 'Envíos', 'Spedizioni'),
    }),
    vocabulary('action_gateway.capability', '@vello/action-gateway Capability', {
        on: L('Ligado', 'On', 'Activado', 'Attivo'),
        off: L('Desligado', 'Off', 'Desactivado', 'Disattivato'),
    }),
];
//# sourceMappingURL=governance-market.js.map